// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"478":"f248a356c3081ce1","496":"83edc8afc0370428","505":"fd4a7a3e325b9471"}[chunkId] + ".js";
};